import React from 'react'
import PropTypes from 'prop-types'

import Badges from '../components/PageHome/Badges'
import Hero from '../components/PageHome/Hero'
import ContentBlock from '../components/ContentBlock'
import Button from '../components/Button'
import Slider from '../components/Slider'

import localization from '../localization/home'

import img_logo from '../assets/shared/logo.svg'
import img_hero1 from '../assets/home/hero1.jpg'
import img_hero2 from '../assets/home/hero2.jpg'
import img_hero3 from '../assets/home/hero3.jpg'
import img_introductionSlider1 from '../assets/home/introductionSlider1.jpg'
import img_introductionSlider2 from '../assets/home/introductionSlider2.jpg'
import img_introductionSlider3 from '../assets/home/introductionSlider3.jpg'
import img_introductionSlider4 from '../assets/home/introductionSlider4.jpg'
import img_introductionSlider5 from '../assets/home/introductionSlider5.jpg'
import img_introductionSlider6 from '../assets/home/introductionSlider6.jpg'
import img_reviewsImage from '../assets/home/reviewsImage.jpg'

const IndexPage = (props) => {
  const { language } = props

  const sliderImages = [
    { image: img_hero1 },
    { image: img_hero2 },
    { image: img_hero3 }
  ]

  const introductionSliderImages = [
    { image: img_introductionSlider1, alt: localization[language].introductionSlider1Alt },
    { image: img_introductionSlider2, alt: localization[language].introductionSlider2Alt },
    { image: img_introductionSlider3, alt: localization[language].introductionSlider3Alt },
    { image: img_introductionSlider4, alt: localization[language].introductionSlider4Alt },
    { image: img_introductionSlider5, alt: localization[language].introductionSlider5Alt },
    { image: img_introductionSlider6, alt: localization[language].introductionSlider6Alt }
  ]

  return (
    <React.Fragment>
      <Hero
        images={sliderImages}
        backgroundColor="#FFFFFF"
        overlayContent={<img src={img_logo} alt="Ferienhaus Vulkaneifel Kopp" width="280" />}
      />

      <Badges language={language} />

      <ContentBlock split reverse darkBackground sliderRight>
        <div>
          <h2 className="t-heading-s">{localization[language].introductionTitle}</h2>
          <p>{localization[language].introductionP1}</p>
          <p>{localization[language].introductionP2}</p>
          <br />
          <Button type="link" to={localization[language].introductionButtonTarget} size="large">{localization[language].introductionButton} »</Button>
        </div>

        <div>
          <Slider images={introductionSliderImages} />
        </div>
      </ContentBlock>

      <ContentBlock split>
        <div>
          <h2 className="t-heading-s">{localization[language].reviewsTitle}</h2>
          <p>{localization[language].reviewsP1}</p>
          <p>{localization[language].reviewsP2}</p>
          <br />
          <Button type="anchor" to={localization[language].reviewsButtonTarget} target="_blank" size="large">{localization[language].reviewsButton} »</Button>
        </div>
        <div style={{ backgroundImage: `url(${img_reviewsImage})` }} />
      </ContentBlock>
    </React.Fragment>
  )
}

IndexPage.propTypes = {
  language: PropTypes.string.isRequired,
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js